import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useContent } from "@/context/ContentContext";
import { Editor, sectionLabel } from "@/components/admin/ContentEditor";

export const ContentPanel = () => {
  const { reload } = useContent();
  const [draft, setDraft] = useState(null);
  const [section, setSection] = useState("settings");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/content").then((r) => setDraft(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/content", { content: draft });
      setDraft(data);
      reload();
      toast.success("Changes saved and live on the site");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  const reset = async () => {
    if (!window.confirm("Restore all page copy to the original text? Your email and Calendly links are kept.")) return;
    try {
      const { data } = await api.post("/admin/content/reset");
      setDraft(data);
      reload();
      toast.success("Original copy restored");
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  if (!draft) return <p className="text-[#6B7280]">Loading…</p>;
  return (
    <div className="grid gap-8 md:grid-cols-[200px_1fr]">
      <nav aria-label="Sections" className="flex gap-2 overflow-x-auto md:flex-col">
        {Object.keys(draft).map((k) => (
          <button key={k} onClick={() => setSection(k)} className={`whitespace-nowrap rounded-full px-4 py-2 text-left text-sm transition-colors duration-300 ${section === k ? "bg-[#6F5B9E] text-white" : "text-[#22304A] hover:bg-[#B9A9D8]/20"}`} data-testid={`admin-section-${k}`}>
            {k === "settings" ? "Settings" : sectionLabel(k)}
          </button>
        ))}
      </nav>
      <div>
        <div className="card-soft p-6 sm:p-8">
          <h2 className="mb-6 text-2xl text-[#22304A]">{sectionLabel(section)}</h2>
          <Editor path={[section]} value={draft[section]} onChange={(v) => setDraft({ ...draft, [section]: v })} />
        </div>
        <div className="sticky bottom-0 mt-6 flex flex-wrap items-center gap-4 bg-[#FAF8F4]/95 py-4">
          <button onClick={save} disabled={saving} className="btn-primary" data-testid="admin-save-button">{saving ? "Saving…" : "Save changes"}</button>
          <button onClick={reset} className="text-sm text-[#6B7280] underline-offset-4 hover:underline" data-testid="admin-reset-button">Restore original copy</button>
        </div>
      </div>
    </div>
  );
};
